// extracted by mini-css-extract-plugin
export default {"open_content":"OpenInformation_open_content_Oesa4","open_content_body":"OpenInformation_open_content_body_JC3pp"};